// extracted by css-extract-rspack-plugin
export default {"cardWrap":"DownloadRoster__cardWrap--jEQ8u","description":"DownloadRoster__description--MU79x"};